<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Detaljna pretraga
        <small v-if="ip.address != ''">
          <span>IP: <strong>{{ ip.address }}</strong>, </span>
          <span>City: <strong>{{ ip.city }}</strong>, </span>
          <span>Country: <strong>{{ ip.country }}</strong>, </span>
          <span>ISP: <strong>{{ ip.isp }}</strong></span>
        </small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <form class="form-horizontal">
            <div class="col-md-2">
              <div class="form-group">
                  <select v-model="type" id="type" class="form-control">
                    <option value="nickname" selected>Nickname</option>
                    <option value="ip">IP</option>
                  </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="margin-input form-group">
                  <input v-model="term" type="text" id="term" :placeholder="type" focus class="form-control">
              </div>
            </div>
            <div class="col-md-4">
              <button  @click="searchUser()" type="button" class="btn btn-primary">Search</button>
              <button @click="aboutUser()" v-if="userInfo.id != 0" type="button" class="btn btn-info">ID: {{ userInfo.id }}</button>
            </div>

          </form>
        </div>
      </div>
      <div v-if="error.length > 0" class="alert alert-danger" role="alert">
        {{ error }}
      </div>
      <div class="col-xs-6">
        <ul class="list">
          <li v-for="dt in data.nicknames" @click="copyNick(dt)">
            <span>{{ testUri(dt) }} </span>
          </li>
        </ul>
      </div>
      <div class="col-xs-6">

        <ul class="list">
          <li v-for="ip in data.allIp" @click="copyIP(ip)">
            <span>{{ ip }}</span>
          </li>
        </ul>
    </div>
      <div class="col-sm-4">
      </div>

      <!-- Modal -->
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Informacije o igraču:</h4>
            </div>
            <div class="modal-body">
              <form class="form-horizontal">

                <div v-if="userInfo.id != 0">

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="user_id">ID:</label>
                    <div class="col-sm-9">
                      <input type="text" :value="userInfo.id" class="form-control" id="user_id" disabled>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="nickname">Nickname:</label>
                    <div class="col-sm-9">
                      <input type="text"  :value="testUri(userInfo.nickname)" class="form-control" id="nickname">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="email">Email:</label>
                    <div class="col-sm-9">
                      <input type="text"  :value="userInfo.email" class="form-control" id="email" placeholder="Enter email">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="password_view">Password:</label>
                    <div class="col-sm-9">
                      <input type="text"  :value="userInfo.password_view" class="form-control" id="password_view">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="coins">Coins:</label>
                    <div class="col-sm-9">
                      <input type="number"  :value="userInfo.coins" class="form-control" id="coins">
                    </div>
                  </div>

                  <div class="form-group" v-if="userInfo.facebook_id != null">
                    <label class="control-label col-sm-3" for="nickname">Facebook:</label>
                    <div class="col-sm-9">
                      <div>
                        <a :href="'https://facebook.com/' +  userInfo.facebook_id">{{ userInfo.firstname }} {{ userInfo.lastname }}</a>
                      </div>
                      <div>
                        <p>Age Range: {{ userInfo.age_range }}</p>
                      </div>

                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="skins-cards">Private skins:</label>
                  </div>
                  <div class="ui six stackable cards" id="skins-cards"  v-if="userInfo.skins.length">
                    <div class="col-sm-6 col-md-4 col-lg-3 card" :data-skin-id="item.id" v-for="item in userInfo.skins">
                      <img class="card-img-top" :src="'https://agar.rs/public/images/skins/'+item.skin_name+'.png'">
                      <div class="card-block">

                        <div class="card-text">
                          {{  item.ip }}
                        </div>
                      </div>
                      <div class="card-footer">
                        <!--<h4 class="text-center card-title mt-3">{{ item.user_id }}</h4>-->
                        <!--<h4 class="text-center card-title mt-3" >{{ decodeURI(item.nickname) }}</h4>-->
                        <!--&lt;!&ndash;<a style="font-size:14px;" :href="'https://fb.com/' + item.facebook_id"> | {{ item.firstname}} {{ item.lastname}}</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;</h4>&ndash;&gt;-->


                        <!-- <button @click="removePrivateSkinDB(item.id, item.skin_name)" class="btn btn-danger float-right btn-sm">Delete</button> -->

                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </form>


            </div>

          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'allInfo',

    data: function () {
      return {
        form: new Form({}),
        data: {
          nicknames: [],
          allIp: []
        },
        ip: {
          address: ''
        },
        userInfo: {
          id: 0,
          skins: []
        },
        role: 0,
        term: '',
        type: 'nickname',
        error: ''
      }
    },
    computed: {
    },
    methods: {
      testUri: function (arg) {
        var valu = ''
        try {
          valu = decodeURI(arg)
        } catch (err) {
          valu = arg
          console.log('greska')
        }
        return valu
      },
      aboutUser: function () {
        $('#myModal').modal('show')
        this.form.post(baseUrl + 'Admin/getUserPrivateSkins/' + this.userInfo['id']).then((result) => {
          if (result.status === 1) {
            this.userInfo.skins = result.list
          }
        }, function (reason) {
        })
      },
      getIpInfo: function (ip) {
        this.form.post('https://ipapi.co/' + ip + '/json/', {}).then((result) => {
          this.ip['address'] = ip
          this.ip['city'] = result['city'] + ' / ' + result['region'] + ' / ' + result['postal']
          this.ip['country'] = result['country_name']
          this.ip['region'] = result['region']
          this.ip['isp'] = result['org']
        }, function (reason) {
          // rejection
        })
      },
      searchUser: function () {
        let data = {
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log
        }
        this.error = ''
        var searchTerm = this.term
        if (this.type === 'nickname') {
          searchTerm = encodeURI(this.term)
          data['nickname'] = searchTerm
        } else {
          data['ip'] = this.term
        }
        this.data = {
          nicknames: [],
          allIp: []
        }
        this.form.post(baseUrl + 'Admin/allUserInfo', data).then((result) => {
          if (result.status === 1) {
            this.data.nicknames = result.data.nicknames
            this.data.allIp = result.data.all_ip
            this.userInfo.id = Number(result.data.user_id)
          }
        }, (reason) => {
          this.error = JSON.stringify(reason)
        })
      },
      copyNick: function (nick) {
        this.ip['address'] = ''
        this.type = 'nickname'
        this.term = this.testUri(nick)
      },
      copyIP: function (ip) {
        this.type = 'ip'
        this.term = ip
        this.getIpInfo(ip)
      }
    },
    mounted: function () {
      this.role = Number(this.$store.state.role)
      if (Number(this.$store.state.role) < 40) {
        this.$router.push('/dashboard')
      }
    }
  }
</script>
<style>
.list {
  height: calc(100vh - 210px);
  overflow-y: auto;
}
.list li {
  list-style-type: none;
  cursor: pointer;
  padding: 7px 7px;
}
.list li:hover {
  background: #dcdada;
}
.form-horizontal .margin-input {
  margin-left: 0px;
}
@media only screen and (max-width: 768px) {

  .form-horizontal .margin-input {
    margin-left: -15px;
  }
  .list {
    padding-left: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// All-Info.vue?761620c2